import React from "react";
import ChatInterface from "@commons/chat/components/ChatInterface";

const StoreSupportChat = () => {
  return <ChatInterface />;
};

export default StoreSupportChat;
